import { render, staticRenderFns } from "./transfer-coin.vue?vue&type=template&id=35ab1101"
import script from "./transfer-coin.vue?vue&type=script&lang=js"
export * from "./transfer-coin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports